import SearchPageContents from '@/components/Search/SearchPageContents'
import { NextPageContext } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'

interface SearchPageProps {
  from: string
}

const SearchPage: React.FC<SearchPageProps> = ({ from }) => {
  const { t } = useTranslation('common')
  return (
    <SearchPageContents
      from={from}
      query={(searchQuery: string) => `(title:${searchQuery} OR tag:${searchQuery})`}
      searchRecommendationsQuery={''}
      searchPlaceholder={t('common:Word_Search')}
      searchPageHref='/search'
    />
  )
}

export const getServerSideProps = async (ctx: NextPageContext) => {
  const { locale, defaultLocale, req } = ctx
  return {
    props: {
      ...(await serverSideTranslations(locale || defaultLocale || 'id', [
        'common',
        'pcp',
        'mto',
        'rfq',
      ])),
      from: req?.headers.referer || '',
    },
  }
}

export default SearchPage
